import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { CustomSelect } from '../../../../ui/custom_react_select/custom_select';
import { TextInput } from '../../../../ui/input/text_input/text_input';
import { SelectOptions } from '../../../../utils/types/react_select_types';
import { COMPANY_SIZE_OPTIONS } from '../constants';
import type { IIdentitySectionProps } from '../interfaces';

export const IdentitySection: React.FC<IIdentitySectionProps> = ({
  organizationName,
  companySize,
  domains,
  onOrganizationNameChange,
  onCompanySizeChange,
  onDomainsChange,
}) => (
  <Box>
    <Typography
      variant="caption"
      sx={{
        fontWeight: 800,
        color: 'text.secondary',
        textTransform: 'uppercase',
        letterSpacing: '0.15em',
        display: 'block',
        mb: 3,
      }}
    >
      Identity
    </Typography>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
        gap: 3,
      }}
    >
      <TextInput
        label="Organization Name"
        name="name"
        value={organizationName}
        type="text"
        placeholder="e.g. Acme Corporation"
        onChange={(e) => onOrganizationNameChange(e.target.value)}
      />
      <CustomSelect
        label="Company Size"
        name="size"
        options={COMPANY_SIZE_OPTIONS}
        placeholder="Select size..."
        value={COMPANY_SIZE_OPTIONS.find((option) => option.value === companySize) ?? null}
        onChange={(option: SelectOptions | null) => {
          if (option) onCompanySizeChange(option.value as typeof companySize);
        }}
      />
      <TextInput
        label="Approved Domains"
        name="domains"
        value={domains}
        type="text"
        placeholder="acme.com, acme.io (comma separated)"
        onChange={(e) => onDomainsChange(e.target.value)}
      />
    </Box>
    <Typography variant="caption" sx={{ mt: 1.5, color: 'text.secondary', fontWeight: 500, display: 'block' }}>
      User emails must match these domains to join automatically.
    </Typography>
  </Box>
);
